import ModalSummary from './ModalSummary';

export default ModalSummary;
